import { library } from '@fortawesome/fontawesome-svg-core'

import { faCheck, faXmark, faRotateRight } from '@fortawesome/sharp-solid-svg-icons'

library.add(faCheck, faXmark, faRotateRight );